import Backbone from 'backbone';

/**
 * @member [parseCollection] ParseCollection
 */

var ParseCollection = Backbone.Collection.extend(
    /** @lends Backbone.Collection */
    {
        // if isLoading is false then call initialize function
        isLoading: false,
        /**
         * starts to load Collection
         * @function initialize
         * @constructor
         */
        initialize: function () {
            this.on('isLoading', isLoading => {
                this.isLoading = isLoading;
            })
        }
    });
/**
 * ParseCollection, helps to exports a dynamic object [Data Collection]
 * @module collections/parseCollection
 */
export default ParseCollection;